import { FC } from 'react';

import { Button } from '@purpur/library';
import { Icon } from '@purpur/library/icon';
import { chevronLeft } from '@purpur/library/icon/assets/chevron-left';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { RetailsTestID } from '../../test-ids';
import { useRetailsContext } from '../RetailsContext';

export const GoBackButton: FC = () => {
    const { t } = useTranslations();

    const { selectSalon, selectedSalon, selectedCity } = useRetailsContext();

    if (!selectedSalon || !selectedCity || selectedCity.salons.length === 1) {
        return null;
    }

    const handleGoBackClick = () => {
        selectSalon(undefined);
    };

    return (
        <div>
            <Button variant="text" onClick={handleGoBackClick} data-test={RetailsTestID.SALON_GO_BACK}>
                <Icon svg={chevronLeft} /> {t['retails_map.salon.back']}
            </Button>
        </div>
    );
};
